import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FrameworkAgreementDto, useTerminateFrameworkAgreementMutation } from "../../autogen/bff-api";
import { useApiError } from "../../common/errors/useApiError";
import { useConfirmationModal } from "../../common/useConfirmationModal";

export const TerminateFrameworkAgreementButton = ({ framework }: { framework: FrameworkAgreementDto }) => {
  const { t } = useTranslation();
  const displayer = useApiError();
  const confirmationModal = useConfirmationModal();
  const [terminate, { isLoading }] = useTerminateFrameworkAgreementMutation();

  const confirm = () =>
    confirmationModal.show({
      title: t("Terminate framework agreement?"),
      description: t(
        "No further call-offs or mini-competitions can be made. Contracts already signed are unaffected.",
      ),
      confirmButtonText: t("Terminate") ?? "Terminate",
      confirmButtonColor: "red",
      onConfirmed: async () => {
        try {
          await terminate({ frameworkAgreementId: framework.id }).unwrap();
        } catch (e) {
          displayer.trigger(e);
        }
      },
    });

  return (
    <>
      {confirmationModal.modal}
      <Button variant="outline" colorScheme="red" size="sm" isLoading={isLoading} onClick={confirm}>
        {t("Terminate")}
      </Button>
    </>
  );
};
